module.exports = __webpack_public_path__ + "static/img/1718785459886.968496bb.jpg";